export default [
    {
      path: 'dataTableList',
      name: { list: ['产业大数据', '数据', '数据面板', '动态建表'] },
      component: () => import('@/views/dataAcquisition/dataTable.vue')
    },
    {
      path: 'dataTableEdit',
      name: { list: ['产业大数据', '数据', '数据面板', '动态建表','编辑'] },
      component: () => import('@/views/dataAcquisition/dataTableEdit.vue')
    },
    {
      path: 'dataTableDetail',
      name: { list: ['产业大数据', '数据', '数据面板', '动态建表','详情'] },
      component: () => import('@/views/dataAcquisition/dataTableEdit.vue')
    },
    {
      path: 'dataManagementList',
      name: { list: ['产业大数据', '数据', '数据面板', '数据管理'] },
      component: () => import('@/views/dataAcquisition/dataManagement.vue')
    },
    {
      path: 'dataManagementEdit',
      name: { list: ['产业大数据', '数据', '数据面板', '数据管理','编辑'] },
      component: () => import('@/views/dataAcquisition/dataManagementEdit.vue')
    },
    {
      path: 'dataManagementCustom',
      name: { list: ['产业大数据', '数据', '数据面板', '数据管理','配置'] },
      component: () => import('@/views/dataAcquisition/dataManagementEdit.vue')
    },
  ]